module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.b771a0ae.ttf";